// https://support.playwire.com/v1/docs/ad-units-array-for-ads-api#tagless-ad-units
export enum TaglessAdUnits {
  BottomRail = "bottom_rail",
  FlexLeaderboard = "flex_leaderboard",
  LeftRail = "left_rail",
  RightRail = "right_rail",
  CornerAdVideo = "corner_ad_video",
  StickySidebar = "sticky_sidebar",
  Sidebar = "sidebar",
  InContent = "in_content",
}

// https://support.playwire.com/v1/docs/ad-units-array-for-ads-api#2
// ATF = Above the Fold
// BTF = Below the Fold
export enum TagBasedAdUnits {
  LeaderboardATF = "leaderboard_atf",
  LeaderboardBTF = "leaderboard_btf",
  MediumRectATF = "med_rect_atf",
  MediumRectBTF = "med_rect_btf",
  SkyscraperATF = "sky_atf",
  SkyscraperBTF = "sky_btf",
}

// Custom named placements configured in the Ramp/Playwire dashboard. Consumed as a `type` +
// `selectorId` via ramp.addUnits, exactly like the units above — no data-pw-desk attribute needed.
export enum NamedAdUnits {
  StandardIabFoot1 = "standard_iab_foot1",
}

export type RampWindow = {
  PageOS: any;
  Bolt: BoltVideoPlayer;
  ramp: {
    que: any[];
    passiveMode: boolean;
    forcePath: string;
    settings: {
      slots: object;
    };
    setPath: (path: string) => void;
    addUnits: (units: any) => Promise<void>;
    displayUnits: Function;
    destroyUnits: (slots: string[] | "all") => Promise<void>;
    pauseVideo: (slotId: string) => void;
    playVideo: (slotId: string) => void;
    flexLbShown: boolean;
    onPlayerReady: () => void;
  };
} & Window &
  typeof globalThis;

type BoltVideoPlayer = {
  on: (adId: string, eventType: string, cb: () => void) => void;
  BOLT_AD_STARTED: string;
};
